export const DELIVERY_RESTITUTION_ELSEWHERE_PREFIX = 'Restitution Sherlook:';

export const DELIVERY_RESTITUTION_ELSEWHERE_BODY =
  'Cet objet a été restitué à son propriétaire.';

export function isDeliveryRestitutionElsewhereMessage(content: string): boolean {
  return content.startsWith(DELIVERY_RESTITUTION_ELSEWHERE_PREFIX);
}
